import { createContext, type RefObject } from 'react';

interface FormContextProps {
  wrapperRef: RefObject<HTMLFormElement>;
}

const FormContext = createContext<FormContextProps>({ wrapperRef: { current: null } });

export default FormContext;
